import React from 'react';
import Body from './Body';

const View = ({ data }) => <Body data={data} />;

export default View;
